import { Product } from 'common/api/e-comm/models/Product';
import { sortCurrency } from './sortCurrency';

export const selectedProductOptions = (product?: Product | null) => {
    const options = product ? product.options : [];

    return options.reduce(
        (initialProductOptions, o) => ({
            ...initialProductOptions,
            [o.id]: sortCurrency(o.values)[0],
        }),
        {}
    );
};
